import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import { ScheduleData } from './ScheduleDataSource';
import { Col, Row } from 'reactstrap';
import RadioInput from '../RadioInput/RadioInput';
import SelectInput from '../SelectInput/SelectInput';
import CheckBox from '../CheckBox/Checkbox';
import ReactSelect from '../ReactSelect/ReactSelect';
import AddressFrm from '../AddressFrm/AddressFrm';
import { clearAddress } from '../../Shared/AddressFrm/addressFrmSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import BtnPinkSmall from '../Buttons/BtnPinkSmall';
import PopUp from '../Popup/PopUp';
import { callOpenWorkOrderForSale } from '../../../utilities/openWorkOrder';
import {
  deliveryChangeHandler,
  validateHandler,
  getDeliveryTimeSlots,
  startLoading,
  setSelectedOption,
  setIsNewAddress,
  clearTimeSlots,
  deliveryValidateHandler,
  setIsLeaveSimInBox,
  initValidation,
  clearValid,
} from './SetUpDeliveriesSlice';

import { connect } from 'react-redux';

const SetUpDeliveries = (props) => {
  //const [selectedOption, setSelectedOption] = useState('0');
  const [isSubmit, setIsSubmit] = useState(false);
  const [isValidAddress, setIsValidAddress] = useState(false);
  const [isShowWorkOrder, setIsShowWorkOrder] = useState(false);
  const [isShowPopUp, setIsShowPopUp] = useState(false);

  function onCheck() {
    props.setIsLeaveSimInBox({ isLeaveSimInBox: true });
  }

  function onUncheck() {
    props.setIsLeaveSimInBox({ isLeaveSimInBox: false });
  }

  const handleOptionChange = (e) => {
    let current = e.currentTarget;

    if (current.accessKey !== '' && current.accessKey != undefined) {
      props.setSelectedOption(current.accessKey);
     
      if (current.accessKey == '0') {
        props.setIsNewAddress({ form: props.form, value: false });
        if (props.form.street !== '' && props.form.city !== '' && props.form.home !== '') {
          props.clearTimeSlots();
          getTimeSlots();
        }
      } else {
        scrollInto('city');
        props.setIsNewAddress({ form: props.form, value: true });
        props.clearAddress({ form: props.addressForm });
        

      }
    } else {
      props.setSelectedOption(e.target.value);
    }
  };

  const handleHomeChange = (value) => {
    if (props.form.street !== '' && props.form.city !== '' && props.form.home !== '') {
      props.clearTimeSlots();

      if (value) {
        getTimeSlotsForNewAddress();
      }
    }
  };

  const convertProductToStr = (products) => {
    let strProducts = '';
    products.map((product, key) => {
      strProducts += product.productIdDelivery + '_';
    });

    return strProducts.slice(0, -1);
  };

  const convertProductVirtualToStr = (products) => {
    let strProducts = '';
    products.map((product, key) => {
      strProducts += product.productMakatVirtual + '_';
    });

    return strProducts.slice(0, -1);
  };

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        props.hideAppLoader();
      }
    },
    [props.form.deliveryTimeSlots]
  );

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.form.errorObj != '') {
        if (props.saleType == 'internet') props.onError(props.form.errorObj.errorId);

        //hours not found
        if (props.saleType == 'tv' && props.form.errorObj.errorId == 20) {
          props.hideAppLoader();
          setIsShowWorkOrder(true);
        }

        //hours not found
        if (props.saleType == 'cellular' && props.form.errorObj.errorId == 20) {
          props.onError(51);
        }

        if (props.saleType == 'cellular' && props.form.errorObj.errorId == 19) props.onError(50);
      }
    }
  });

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      // from back
      getTimeSlots();
    }
    else // not from back
    {
      getTimeSlots();
    }

    props.initValidation();
  }, []);

  useEffect(() => {
    if (props.onSubmit && props.onSubmit == true) {
      if (props.form.isNewAddress === false || isValidAddress == true) {
        props.deliveryValidateHandler(props.form);
      } else {
        setIsSubmit(true);
      }
    }
  }, [props.onSubmit]);

  useEffect(() => {
    if (props.form.valid !== '') {
      if (!isValidAddress && props.form.isNewAddress) {
        props.onValid(false);
      } else {
        props.clearValid();
        props.onValid(props.form.valid);
      }

      props.initValidation();
    }
  }, [props.form.valid]);

  const handleAddressValidate = (isValid) => {
    if (isValid) {
      setIsValidAddress(true);
    } else {
      setIsValidAddress(false);
    }

    setIsSubmit(false);
    props.deliveryValidateHandler(props.form);
  };

  async function handleWorkOrder() {
    const isOrderSent = await callOpenWorkOrderForSale(props.saleBlock);

    if (isOrderSent) openPopUp();
    else props.onError(0);
  }

  function handleTryAgain() {
    props.showAppLoader();

    if (!isNewAddress) getTimeSlots();
    else getTimeSlotsForNewAddress();
  }

  const getTimeSlots = () => {
    if (props.selectedAddress) {
      let selectedProducts = '';

      if (props.saleType == 'cellular') selectedProducts = convertProductVirtualToStr(props.productsInfo.selectedProducts);
      else {
        selectedProducts = convertProductToStr(props.productsInfo.selectedProducts);
      }

      const params = {
        city: props.selectedAddress.cityName,
        street: props.selectedAddress.streetName,
        homeNum: props.selectedAddress.home,
        products: selectedProducts,
      };
      props.getDeliveryTimeSlots(params);
    }
  };

  const getTimeSlotsForNewAddress = () => {
    let selectedProducts = '';
    
    if (props.saleType == 'cellular') selectedProducts = convertProductVirtualToStr(props.productsInfo.selectedProducts);
    else {
      selectedProducts = convertProductToStr(props.productsInfo.selectedProducts);
    }

    const params = {
      city: props.addressForm.cityName,
      street: props.addressForm.streetName,
      homeNum: props.addressForm.home,
      products: selectedProducts,
    };

    let isNumber = /^\d+$/.test(props.addressForm.home);
    if (isNumber) props.getDeliveryTimeSlots(params);
  };


  const closePopUp = () => {
    setIsShowPopUp(false);
  };

  const openPopUp = () => {
    setIsShowPopUp(true);
  };

  const scrollInto = (inputName) => {
    const input = document.querySelector('input[name=' + inputName + ']');

    if (input !== null) {
      input.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <div className='container-fluid main' style={{ paddingRight: '4px', paddingLeft: '4px' }}>
      <div className='component-container' style={{ marginTop: '15px' }}>
        <div className='setup-deliveries'>
          <div accessKey='0' className='radio-bg' onClick={handleOptionChange}>
            <div className='radio-container'>
              <RadioInput
                onChange={handleOptionChange}
                id='myAddress'
                name='groupDeliveries'
                value='0'
                checked={props.form.selectedOption === '0'}
                label=''
              />
            </div>
            <div className='text-container'>
              <div>
                <span>חשבון שבכתובת:</span>
                <br />
                {props.selectedAddress ? <span className='bold-line'>{props.selectedAddress.streetName} {props.selectedAddress.home}, {props.selectedAddress.cityName}</span> : <span className='bold-line'></span>}
              </div>
            </div>
          </div>

          <div accessKey='1' className='radio-bg' onClick={handleOptionChange}>
            <div className='radio-container'>
              <RadioInput
                onChange={handleOptionChange}
                id='otherAddress'
                name='groupDeliveries'
                value='1'
                checked={props.form.selectedOption === '1'}
                label=''
              />
            </div>
            <div className='text-container'>
              <div>
                <span>כתובת אחרת</span>
              </div>
            </div>
          </div>
          {props.form.selectedOption === '1' ? (
            <AddressFrm onHomeChange={handleHomeChange} onSubmit={isSubmit} onValid={handleAddressValidate} title='כתובת למשלוח' />
          ) : (
              ''
            )}
        </div>
      </div>
      <br />
      <div className='component-container' style={{ marginTop: '-2px' }}>
        <div className='setup-deliveries'>
          <p>המועד הקרוב ביותר שנוכל להגיע:</p>
          <div className='spacer'></div>
          <Row>
            <Col ms={12}>
              <ReactSelect
                inputProps={{ readOnly: true }}
                isSearchable={false}
                error={props.form.errors.deliveryTime}
                getOptionLabel={(option) => option.value}
                getOptionValue={(option) => option.key}
                placeholder='בחר מועד'
                isLoading={props.form.isLoading}
                value={props.form.deliveryTimeSlots.filter((option) => option.key === props.form.deliveryTime)}
                name='deliveryTime'
                options={props.form.deliveryTimeSlots}
                onChange={(e) =>
                  props.deliveryChangeHandler({
                    target: {
                      name: 'deliveryTime',
                      value: e.key,
                      startDate: e.startDate,
                      endDate: e.endDate,
                      round: e.round,
                      roundName: e.roundName,
                      waitFrom: e.waitFrom,
                      waitTo: e.waitTo,
                      lfdat: e.lfdat,
                      weekdayL: e.weekdayL,
                      pickLocation: e.pickLocation,
                    },
                    form: props.form,
                  })
                }
              />

              <PopUp showPopUp={isShowPopUp} onClose={closePopUp}>
                <div>
                  <p className='top-title'>פנייתך נשלחה ותענה בהקדם</p>
                </div>
                <div className='btn-pink-holder'>
                  <BtnPinkSmall
                    text='סגירה'
                    onclick={() => {
                      closePopUp();
                    }}
                  />
                </div>
              </PopUp>

              {isShowWorkOrder ? (
                <div style={{ textAlign: 'center' }}>
                  <span className='message'>לא נמצאו מועדי שליחויות</span>
                  <br />
                  <div style={{ display: 'inline-block' }}>
                    <div className='sale-product-btn-wrapper'>
                      <a className='btn-add-settopbox' href='#' onClick={handleWorkOrder}>
                        פניה לנציג
                      </a>
                    </div>
                    <div className='sale-product-btn-wrapper'>
                      <a className='btn-add-settopbox' href='#' onClick={handleTryAgain}>
                        נסה שוב
                      </a>
                    </div>
                  </div>
                </div>
              ) : (
                  ''
                )}

              {props.isDisplayLeaveSimInBox ? (
                <CheckBox
                  checked={props.form.isLeaveSimInBox}
                  label='תשאירו את ה-SIM בתיבה'
                  id='cbxIsLeaveSimInBox'
                  onCheck={() => onCheck()}
                  onUncheck={() => {
                    onUncheck();
                  }}></CheckBox>
              ) : (
                  ''
                )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    form: state.setupDeliveries.form,
    addressForm: state.addressForm.form,
    productsInfo: state.saleBlock.productsInfo,
    saleBlock: state.saleBlock,
  };
};

const mapDispatchToProps = {
  deliveryChangeHandler,
  deliveryValidateHandler,
  getDeliveryTimeSlots,
  startLoading,
  setSelectedOption,
  setIsNewAddress,
  clearTimeSlots,
  clearAddress,
  setIsLeaveSimInBox,
  showAppLoader,
  hideAppLoader,
  initValidation,
  clearValid,
};

export default connect(mapStateToProps, mapDispatchToProps)(SetUpDeliveries);
